<template>
  <p
    data-test="app-badge"
    :class="[
      'flex min-w-[20px] h-[20px] px-[6px] items-center justify-center rounded-full text-surf-lock-wht text-label-m-12-18',
      {
        'bg-black-400': disabled,
        'bg-surf-brand-basedarkblue-def': !disabled,
      },
    ]"
  >
    <span
      v-if="value <= NOTIFICATIONS_COUNT_LIMIT"
      class="relative"
      data-test="app-badge-value"
    >{{ value }}</span>
    <span
      v-else
      class="relative"
      data-test="app-badge-plus"
    >{{ NOTIFICATIONS_COUNT_LIMIT }}+</span>
  </p>
</template>

<script lang="ts" setup>
const { value } = defineProps<{
  value: number
  disabled?: boolean
}>()

const NOTIFICATIONS_COUNT_LIMIT = 99
</script>
